.page {
  padding: 1.5rem 2rem 3rem;
  max-width: 56rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.home {
  color: var(--muted);
  font-family: var(--font-mono);
  font-size: var(--text-min-mono);
}

.sectionHeader {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.pageTitle {
  font-family: var(--font-display);
  margin: 0;
}

.subtitle {
  color: var(--muted);
  margin: 0.25rem 0 0;
}

.trends {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.75rem;
}

.sectionTitle {
  font-family: var(--font-display);
  font-size: 1.1rem;
  margin: 0 0 0.25rem;
}

.sectionSubtitle {
  color: var(--muted);
  font-size: var(--text-min-body);
  margin: 0 0 0.75rem;
}

.detailList {
  margin: 0;
}

.detailRow {
  display: flex;
  justify-content: space-between;
  padding: 0.4rem 0;
  border-bottom: 1px solid var(--rule);
  font-family: var(--font-mono);
  font-size: var(--text-min-mono);
}

.detailRow dt {
  color: var(--ink-soft);
}

.detailRow dd {
  margin: 0;
  color: var(--ink);
}

.subList {
  margin: 0.5rem 0 0;
  padding-left: 1.25rem;
  color: var(--muted);
  font-family: var(--font-mono);
  font-size: var(--text-min-mono);
}

.unavailable {
  color: var(--muted);
  font-family: var(--font-mono);
  font-size: var(--text-min-mono);
  border: 1px solid var(--line);
  border-radius: var(--radius-sharp);
  padding: 0.875rem 1rem;
  background: var(--paper-2);
}

.error {
  color: var(--stop);
}
